// src/mocs/handlers/dashboard/latestAdvancesHandler.ts

import { rest } from 'msw';
import latestAdvances from '@/mocks/data/dashboard_latestAdvances.json';
import { API_ENDPOINTS } from '@/services/api/endpoints';
import { VITE_MSW_BASE_URL } from '@/config';
import { ILatestAdvancesItem } from '@/domains/dashboard/latestAdvances/latestAdvances.types';
import { format } from 'date-fns';

export const latestAdvancesHandler = rest.get<ILatestAdvancesItem>(
  `${VITE_MSW_BASE_URL}${API_ENDPOINTS.DASHBOARD_LATEST_ADVANCES}`,
  (req, res, ctx) => {
    const token = req.headers.get('Authorization');
    if (!token) {
      return res(ctx.status(500), ctx.json({ detail: 'Something went wrong' }));
    }

    const { customer_uuid } = req.params as { customer_uuid: string };
    const match = latestAdvances.find((entry) => entry.uuid === customer_uuid);

    const latest_advance_date =
      match && match.latest_advance_date
        ? format(new Date(match.latest_advance_date), 'yyyy-MM-dd')
        : null;

    const updated_at = match
      ? format(new Date(match.updated_at), 'yyyy-MM-dd')
      : format(new Date(), 'yyyy-MM-dd');

    const mockResponse: ILatestAdvancesItem = {
      aggregated_advances: {
        amount: match ? match.aggregated_advances.amount : 0,
        currency: match ? match.aggregated_advances.currency : 'GBP',
      },
      breakdown_by_currency: match ? match.breakdown_by_currency : [],
      latest_advance_date: latest_advance_date,
      updated_at: updated_at,
    };

    return res(ctx.status(200), ctx.json(mockResponse));
  },
);
